import { isEmpty, isEqual } from 'lodash';

export const convertSpacesToHyphens = str => str.split(' ').join('-');

export const isDataEqual = (data, immutableData) =>
  !isEmpty(data) && !isEqual(data, immutableData);
